import { usersByBranchService } from "@/apis/services"
import { IPaginationMeta, IUsersByBranchParams, IUsersByBranch } from "@/types"
import { create } from "zustand"
import { devtools } from "zustand/middleware"

interface IUsersByBranchState {
  usersByBranch: IUsersByBranch[]
  meta?: IPaginationMeta
  isLoading: boolean
  error: string | null
  fetchUsersByBranch: (params: IUsersByBranchParams) => Promise<void>
}

const initialState = {
  usersByBranch: [],
  meta: undefined,
  isLoading: false,
  error: null,
}

export const useUsersByBranchStore = create<IUsersByBranchState>()(
  devtools(set => ({
    ...initialState,

    fetchUsersByBranch: async (params: IUsersByBranchParams) => {
      set({ isLoading: true, error: null })

      try {
        const response = await usersByBranchService.getUsersByBranch(params)
        set({ usersByBranch: response.data.items, meta: response.data.meta })
      } catch (error) {
        const errorMessage: string = error instanceof Error ? error.message : "An unknown error occured"
        set({ error: errorMessage })
      } finally {
        set({ isLoading: false })
      }
    },
  }))
)
